import wretch from 'wretch';

import { ILeadResponseModel, IManagerResponseModel } from '@crm-lead/base';

export async function apiGetLead(leadId: number): Promise<ILeadResponseModel> {
  return wretch(`/api/accountmanagement/lead/${leadId}`).get().json();
}

export async function apiGetManagersInfo(
  leadId: number
): Promise<IManagerResponseModel> {
  return wretch('/api/accountmanagement/assigned-managers')
    .query({ leadId })
    .get()
    .json();
}
